Vue.component('manage-commissions', {
    props: ['client-id'],

    data () {
        return {
            loading: false,

            commissions: [],

            createForm: $.extend(true, new Form({
                data: {
                    name: '',
                    sale_type: '',
                    commission_type: '',
                    multipliable: 0,
                    sa_commission: '',
                    nc_commission: ''
                }
            }), {}),

            editForm: $.extend(true, new Form({
                data: {
                    name: '',
                    sale_type: '',
                    commission_type: '',
                    multipliable: 0,
                    sa_commission: '',
                    nc_commission: ''
                }
            }), {}),

            deleteId: 0,

            deleting: false,

            editId: 0
        };
    },

    mounted () {
        this.getCommissions();
    },

    methods: {
        getCommissions() {
            this.loading = true;

            axios.get('/api/commissions', {
                params: {
                    client_id: this.clientId
                }
            }).then(response => {
                this.commissions = response.data;
                this.loading = false;
            });
        },

        create() {
            Http.post('/api/commissions/create', this.createForm, {
                params: {
                    client_id: this.clientId
                }
            }).then((response) => {
                // Reset, no need to display
                this.createForm.resetForm();
                this.createForm.resetAlert();

                // Reload the main list
                this.getCommissions();

                // Open the DNS information
                $('#commissions-create').modal('hide');
            });
        },

        remove (id) {
            this.deleteId = id;

            $('#commissions-delete').modal('show');
        },

        doRemove () {
            this.deleting = true;

            axios.post('/api/commissions/delete', {}, {
                params: {
                    id: this.deleteId
                }
            }).then( response => {
                if (response.status === 200) {
                    $('#commissions-delete').modal('hide');

                    this.deleting = false;

                    this.getCommissions();
                }
            });
        },

        edit (commission) {
            this.editForm.data = commission;
            this.editId = commission.id;
            this.editForm.data.multipliable = this.editForm.data.multipliable === '1' ? 1 : 0;

            $('#commissions-edit').modal('show');
        },

        update () {
            Http.post('/api/commissions/update', this.editForm, {
                params: {
                    client_id: this.clientId,
                    id: this.editId
                }
            }).then((response) => {
                // Reset, no need to display
                this.editForm.resetForm();
                this.editForm.resetAlert();

                // Reload the main list
                this.getCommissions();

                // Open the DNS information
                $('#commissions-edit').modal('hide');
            });
        }
    }
});